import { VSheet } from 'vuetify/lib/components/VSheet';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.formatted)?_c(VSheet,{staticClass:"!tw-z-index-1",attrs:{"elevation":"4"}},[_c('div',{staticClass:"pa-2"},[_c('pre',{staticClass:"font-weight-bold"},[_vm._v(_vm._s(_vm.formatted))])])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }